module.exports = __webpack_public_path__ + "static/media/thankyou_page_image.1517c6a8.svg";